<template>
  <div>
    <div class="u-hd">
        <div class="hd-bk" @click="goBack">
            <i class="icon iconback" ></i>&nbsp;返回
        </div>
        <div class="hd-tl">商品销售报表</div>
        <div class="hd-mu" style="line-height: 44px;">
            <i class="icon icongengduo3" style="margin-left: 55%;font-size:22px"  @click="show=!show"></i>
        </div>
    </div>
    <div style="height:44px"></div>
    <div class="search-fixed">
        <div class="search">
            <div class="search-lst">
                <div class="search-lst-tag">
                    <div class="icon icondingdanhao"></div>
                    <div class="lst-tag-vle">
                        <input
                            style="width: 100%;height:28px;border:0px solid #ccc;line-height:28px;" 
                            placeholder-class="placeholder" 
                            v-model="text" 
                            placeholder="编号、条码、名称" 
                            @keyup.enter="search"
                        />
                    </div>
                </div>
                <div class="search-lst-tag" @click="$refs.selectTime.open()">
                    <div class="icon iconriqi"></div>
                    <div class="lst-tag-vle">
                        <div v-if="tabType=='0'">今日</div>
                        <div v-if="tabType=='1'">昨日</div>
                        <div v-if="tabType=='5'">前日</div>
                        <div v-if="tabType=='2'">近一周</div>
                        <div v-if="tabType=='3'">近一月</div>
                        <div v-if="tabType=='4'">自定义日期</div>
                    </div>
                </div>
            </div>
            <div class="search-lst" >
                <div class="search-lst-tag" @click="$refs.selectPick.open()" v-if="$store.state.supplierInfo.businessType=='0'">
                    <div class="lst-tag-vle">
                        <div class="placeholder" v-if="!merchant.id">请选择组织机构</div>
                        <div v-else>{{merchant.name}}</div>
                    </div>
                </div>
                <div class="search-lst-tag" v-else>
                    {{$store.state.supplierInfo.name}}
                </div>
                <div class="search-lst-tag" style="border-bottom:0px;">
                    <div class="search-btn-group">
                        <div class="search-btn" @click="search">
                            <div class="icon iconsousuo"></div>
                            <div style="padding-left:10px;">查询</div>
                        </div>
                        <div style="width:1px;height:20px;background:#bbb"></div>
                        <div class="search-btn" @click="clearSearch">
                            <div class="icon iconzhongzhi"></div>
                            <div style="padding-left:10px;">重置</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div style="height:100px"></div>
    <div style="height: calc(100vh - 154px);margin-top:10px;padding:0px 10px" >
        <van-list
            v-if="list && list.length>0"
            v-model="loadData"
            :finished="allData"
            finished-text="数据已加载完毕"
            @load="onLoad"
            >
            <div style="margin-bottom:10px">
                <div style="display:flex;align-items: center;background-color:#FFF;padding:10px 0px;padding-bottom:0px;" class="sum">
                    <div style="text-align:center;flex:1">
                        <div class="sum-val">{{total.saleCount | money}}</div>
                        <div class="sum-txt">销售数量</div>
                    </div>
                    <div style="width:1px;height:20px;background:#d2cdec"></div>
                    <div style="text-align:center;flex:1">
                        <div class="sum-val">{{total.saleShouldAmount | money}}</div>
                        <div class="sum-txt">应收金额</div>
                    </div>
                    <div style="width:1px;height:20px;background:#d2cdec"></div>
                    <div style="text-align:center;flex:1">
                        <div class="sum-val">{{total.saleRealAmount | money}}</div>
                        <div class="sum-txt">实收金额</div>
                    </div>
                </div>
                <div style="display:flex;align-items: center;background-color:#FFF;padding:10px 0px;padding-top:5px;" class="sum">
                    <div style="text-align:center;flex:1">
                        <div class="sum-val">{{total.refundCount | money}}</div>
                        <div class="sum-txt">退货数量</div>
                    </div>
                    <div style="width:1px;height:20px;background:##d2cdec"></div>
                    <div style="text-align:center;flex:1">
                        <div class="sum-val">{{total.refundShouldAmount | money}}</div>
                        <div class="sum-txt">应退金额</div>
                    </div>
                    <div style="width:1px;height:20px;background:#d2cdec"></div>
                    <div style="text-align:center;flex:1">
                        <div class="sum-val">{{total.refundRealAmount | money}}</div>
                        <div class="sum-txt">实退金额</div>
                    </div>
                </div>
            </div>
            <div style="display:flex;align-items: center;background-color:#4c37b6;padding:10px 0px;margin-bottom:10px" class="sum">
                <div style="text-align:center;flex:1">
                    <div class="sum-txt" style="text-align:left;padding-left:38px;color:#fff">数量合计</div>
                    <div class="sum-val" style="font-size:25px;color:#FFF">{{total.saleCount-total.refundCount | money}}</div>
                </div>
                <div style="width:1px;height:20px;background:#8470e6"></div>
                <div style="text-align:center;flex:1">
                    <div class="sum-txt" style="text-align:left;padding-left:38px;color:#fff">金额合计</div>
                    <div class="sum-val" style="font-size:25px;color:#FFF">{{total.saleRealAmount-total.refundRealAmount | money}}</div>
                </div>
            </div>
            <div class="ct-order" v-for="(item,index) in list">
                <div class="order-item">
                    <div class="item-icon">
                        <i class="icon iconkucun1"></i>
                    </div>
                </div>
                <div class="order-box">
                    <div class="box-group">
                        <div class="box-tl numColor" style="font-size:15px;font-weight:600">{{item.goodsName}}</div>
                    </div>
                    <div class="box-group">
                        <div class="box-text" style="flex:2">{{item.goodsCode?item.goodsCode:'-'}}</div>
                        <div class="box-text">{{item.unit?item.unit:'-'}}</div>
                        <div class="box-text">{{item.goodSpec?item.goodSpec:'-'}}</div>
                    </div>
                    <div class="box-group" style="align-items:center;">
                        <div class="box-text">
                            <div>销售数量：<span class="numColor">{{item.saleCount | money}}</span></div>
                            <div>应收金额：<span class="numColor">{{item.saleShouldAmount | money}}</span></div>
                            <div style="color:#4C37B6">实收金额：<span class="numColor" style="font-weight:600">{{item.saleRealAmount | money}}</span></div>
                        </div>
                        <div style="width:1px;background-color:#d2cdec;height:40px;margin-right:20px"></div>
                        <div class="box-text">
                            <div>退货数量：<span class="numColor">{{item.refundCount | money}}</span></div>
                            <div>应退金额：<span class="numColor">{{item.refundShouldAmount | money}}</span></div>
                            <div style="color:#4C37B6">实退金额：<span class="numColor"  style="font-weight:600">{{item.refundRealAmount | money}}</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </van-list>
        <div v-else>
            <van-empty>
                <template slot="image">
                    <div style="text-align:center;margin-top:50px">
                        <i class="icon iconzanwushuju2" style="font-size:50px;color:#CCC"></i>
                    </div>
                    <div style="color:#CCC;text-align:center">暂无数据</div>
                </template>
            </van-empty>
        </div>
    </div>
    <div v-if="show" class="right-menu" style="z-index:10;background-color:rgba(0,0,0,0.5);width:100vw" @click="show=false"></div>
    <div v-if="show" class="right-menu">
        <div class="link-item">
            <div style="width: 40px;text-align: center;">
                <i class="icon iconbaobiaofenxi" style="font-size: 20px;"></i>
            </div>
            <div style="font-size: 14px;">日统计报表</div>
        </div>
        <div class="link-item">
            <div style="width: 40px;text-align: center;">
                <i class="icon iconbaobiaofenxi" style="font-size: 20px;"></i>
            </div>
            <div style="font-size: 14px;">月统计报表</div>
        </div>
        <div class="link-item">
            <div style="width: 40px;text-align: center;">
                <i class="icon iconbaobiaofenxi" style="font-size: 20px;"></i>
            </div>
            <div style="font-size: 14px;">年统计报表</div>
        </div>
    </div>
    <select-time ref="selectTime" :type.sync="tabType" :typeText.sync="tabText" :st.sync="startTime" :et.sync="endTime"></select-time>
    <select-merchant ref="selectPick" title="选择组织机构" :item.sync="merchant"></select-merchant>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
    data(){
        return {
            text:'',
            list:[
            ],
            tabType:'0',
            tabText:'今日',
            currentPage:1,
            startTime: '',
            endTime: '',
            merchant:{},
            maxDate: new Date(),
            loadData:false,
            allData:false,
            show:false,
            total:{}
        }
    },
    created(){
        this.startTime = this.moment().format("YYYY-MM-DD");
        this.endTime = this.moment().format("YYYY-MM-DD");
        this.merchant=this.$store.state.supplierInfo.defOrg?this.$store.state.supplierInfo.defOrg:{}
        this.search()
    },
    methods:{
        search(){
            this.currentPage=1
            this.getData()
        },
        clearSearch(){
            this.currentPage=1
            this.merchant={}
            this.text=''
            this.getData()
        },
        onLoad(){
            this.currentPage++
            this.getData()
        },
        getData(){
            this.loadData=true
            let st=this.moment(this.startTime).format("YYYY-MM-DD")
            let et=this.moment(this.endTime).format("YYYY-MM-DD")
            this.$request.get("saleReports/goodsSummarys",{startTime:st,endTime:et,keyword:this.text,pageNum:this.currentPage,pageSize:10,merchantId:(this.merchant.id?this.merchant.id:'')}).then(data=>{
                this.loadData=false
                if(this.currentPage>=data.content.totalPage){
                    Toast.success('数据加载完毕');
                    this.allData=true
                }else{
                    this.allData=false
                }
                this.total=data.content.totalSum
                if(this.currentPage>1){
                    this.list=this.list.concat(data.content.content)
                }else{
                   this.list=data.content.content
                }
            })
        },
        changeTabType(type) {
            this.tabType=type
            let startTime=''
            let endTime=''
            if (type == '0') {
                this.tabText='今日'
                startTime = this.moment().format("YYYY-MM-DD");
                endTime = this.moment().format("YYYY-MM-DD");
            } else if (type == '1') {
                this.tabText='昨日'
                startTime = this.moment().add(-1, 'days').format("YYYY-MM-DD");
                endTime = this.moment().add(-1, 'days').format("YYYY-MM-DD");
            } else if (type == '2') {
                this.tabText='近一周'
                startTime = this.moment().subtract(7, 'days').format("YYYY-MM-DD")
                endTime = this.moment().format("YYYY-MM-DD")
            } else if (type == '3') {
                this.tabText='近一月'
                endTime = this.moment().format("YYYY-MM-DD")
                startTime = this.moment().format("YYYY-MM-01")
            } else if (type == '4') {
                this.tabText='自定义数据'
                endTime = new Date(this.moment().format("YYYY-MM-DD"))
                startTime = new Date(this.moment().format("YYYY-MM-01"))
            }
            this.currentPage=1
            this.startTime=startTime
            this.endTime=endTime
            this.getData()
        },
        goBack(){
            this.router.go(-1)
        }
    }
}
</script>

<style scoped>
    .search-fixed{
        z-index: 10;
        position: fixed;
        width: 100%;
        top: 44px;
        left: 0px;
        background-color: #F2F2F2;
        padding: 10px;
        box-sizing: border-box;
        padding-bottom: 0px;
    }
    .search{ 
        /* border-radius: 10rpx; */
        padding:0px 15px 10px 15px;
        background: #FFF;
    }
        /* list搜索box每行样式 */
    .search-lst{
        display:flex;
        justify-content:space-between
    }
    /* list搜索框样式 */
    .search-lst-tag{
        width:48%;
        height:40px;
        line-height: 40px;
        padding-top:5px;
        display: flex;
        border-bottom:1px solid #eee
    }
        /* 搜索框图标样式 */
    .search-lst-tag .icon{
        font-size:18px;
        color:#aaa
    }
        /* 搜索框内容样式 */
    .lst-tag-vle{
        flex:1;
        text-align:center;
        color:#666;
        font-size:13px;
    }
    /* 搜索框未选中样式 */
    .lst-tag-vle .placeholder{
        color:#adadad;
        font-size:13px;
        text-align: left;
    }
        /* 搜索框按钮Box */
    .search-btn-group{
        width:100%;
        display:flex;
        border-radius:8rpx;
        background:#777;
        display:flex;
        align-items:center;
        justify-content:space-between
    }
        /* 搜索框按钮样式 */
    .search-btn{
        color:#fff;
        display:flex;
        width:49%;
        justify-content:center;
        font-size:14px;
    }
.u-search{
    display: flex;
    height: 40px;
    line-height: 40px;
    align-items: center;
}
.u-search .input-place{
    font-size: 14px;
    color: #DDD
}
.u-search .search-box{
    width: calc(100% - 85px);
    display: flex;
    margin:0px 10px;
    background-color: #FFF;
    height: 100%;
    border-radius: 20px;
    padding-left: 15px;
    align-items: center;
}
.u-search .search-box .box-input{
    width: calc(100% - 40px);
}
.u-search .search-box .box-input input{
    border: 0px;
    color: #666;
    font-size: 14px;
    background: rgba(0,0,0,0);
    height: 100%;
}
.u-search .search-box .box-input .input-place{
    color: #ccc;
}
.u-search .search-box .box-icon{
    width: 40px;
    display: flex;
    align-items: center;
    padding-top: 17px;
}
.search-filter{
    font-size: 14px;
    width: 75px;
    display: flex;
    margin:0px 10px;
    height: 40px;
    align-items: center;
    color: #F9F9F9;
    position: relative;
    background: #486ad8;
}
.search-filter .filter-clr{
    text-align: center;
}
.search-filter .filter-clr view{
    color: #FFF;
}
.search-filter .filter-ser{
    flex: 1;
    text-align: center;
}
.search-filter text{
    color: #F9F9F9;
    font-size: 15px;
}
.search-filter .icon{
    font-size: 22px
}
.search-filter .filter-list{
    position: absolute;
    background: rgba(0,0,0,0.6);
    top: 45px;
    width:90px;
    right:10px;
    z-index: 10;
    text-align: center;
    padding:20px;
    padding-top: 5px;
}
.search-filter .list-item{
    color: #FFF;
    border-bottom:1px solid #888;
    font-size: 14px;
    text-align: left;
    height:40px;
    line-height: 40px
}
.m-ct{
    padding: 0px 10px;
}
.ct-order{
    background-color: #fff;
    margin-bottom: 10px;
    padding:5px 0px;
    display: flex;
}
.ct-order .order-item{
    width: 40px;
    text-align: center;
}
.ct-order .order-item .item-icon i{
    color:#4c37b6;
    font-size: 22px;
}
.ct-order .order-box{
    width: calc(100% - 50px);
    padding:6px 0px;
}
.ct-order .order-box .box-tl{
    font-size: 14px;
    flex: 2;
    margin-bottom: 5px
}
.ct-order .order-box .box-text{
    font-size: 12px;
    padding: 4px 0;
    flex: 1;
    box-sizing: border-box;
    color: #888;
}
.ct-order .order-box .box-btn{
    margin-top: 5px;
    width: 90%;
    color: #FFF;
    background-color:#486ADB;
    border-radius: 5px;
    padding: 7px 0px;
    margin-bottom:10px;
    font-size: 14px;
    text-align: center;
}
.ct-order .order-box .box-group{
    display: flex;
}
.ct-order .order-box .box-btn text{
    color: #FFF;
    
}
.ct-order .order-box .box-btn .icon{
    font-size: 15px
}
.sum{
    color:#4c37b6
}
.sum .sum-txt{
    font-size: 12px;
}
.sum .sum-val{
    font-size: 16px;
}
.numColor{
}
.link-item{
    height: 45px;
    line-height: 45px;
    border-bottom: 1px solid #666;
    color: #fff;
    display: flex;
}
.right-menu{
    position: fixed;
    top: 44px;
    right: 0px;
    /* z-index: 10; */
    background-color: #42474A;
    color: #FFF;
    z-index: 10;
    height: calc(100vh - 44px);
    width: 50vw;
}
</style>


// WEBPACK FOOTER //
// src/views/report/goodsSumReport.vue